export default __webpack_public_path__ + "static/Strategy-Roadmap-09dc40eac9a5e82a75d5ba7103a43fd4.webp";